<template>
  <div>
    <Table border :columns="columns5" :data="data5">
      <template slot-scope="{ row, index }" slot="expectDetails">
        <Input
          type="textarea"
          v-model="row.expectDetails"
          v-if="$store.getters.inputShowData"
          :autosize="{ minRows: 3 }"
          :disabled="
            (applyEditFlag == '1' || userDeptFlag != '1') && targetRevisionState
          "
          @on-change="targetItemChange(row, index, 'expectDetails')"
        />
        <span class="textareaHid" v-else>{{ row.expectDetails }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="empDetails">
        <Input
          type="textarea"
          v-model="row.empDetails"
          v-if="$store.getters.inputShowData"
          :autosize="{ minRows: 3 }"
          :disabled="applyEditFlag == '1' || userDeptFlag != '1'"
          @on-change="targetItemChange(row, index, 'empDetails')"
        />
        <span class="textareaHid" v-else>{{ row.empDetails }}</span>
      </template>
      <!-- <template slot-scope="{ row,index }" slot="empDetails">
                <Input type="textarea" v-model="row.empDetails" :autosize="{minRows: 3}" :disabled="applyEditFlag=='1'" @on-change="targetItemChange(row,index,'empDetails')"/>
            </template> -->
      <template slot-scope="{ row, index }" slot="indirSupFeedback">
        <Input
          type="textarea"
          v-model="row.indirSupFeedback"
          :autosize="{ minRows: 3 }"
          :disabled="
            applyEditFlag == '1' || (userDeptFlag != '3' && userDeptFlag != '4')
          "
          @on-change="targetItemChange(row, index, 'indirSupFeedback')"
        />
      </template>
      <template slot-scope="{ row, index }" slot="dirSupFeedback">
        <Input
          type="textarea"
          v-model="row.dirSupFeedback"
          v-if="$store.getters.inputShowData"
          :autosize="{ minRows: 3 }"
          :disabled="
            applyEditFlag == '1' || (userDeptFlag != '2' && userDeptFlag != '4')
          "
          @on-change="targetItemChange(row, index, 'dirSupFeedback')"
        />
        <span class="textareaHid" v-else>{{ row.dirSupFeedback }}</span>
      </template>
      <template slot-scope="{ row }" slot="status">
        <span style="color:red" v-if="row.status == '新增'"
          ><!-- 新增 -->{{ $t("Add") }}</span
        >
        <!-- <span style="color:red" v-if="row.status=='删除'">删除{{$t('Delete')}}</span> -->
        <span style="color:red" v-if="row.status == '编辑'"
          ><!-- 编辑 -->{{ $t("Edit") }}</span
        >
      </template>
    </Table>
  </div>
</template>

<script>
import columns from "./columns.js";
export default {
  props: ["tabName"],
  data() {
    return {
      columns5: [],
      status: "",
      applyEditFlag: "",
      userDeptFlag: "",
      data5: [
        {
          criterionType: "协同一致",
          enCriterionType: "Alignment",
          activesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left">我理解我们的共同目标，并知晓如何通过我的行动确保共同目标的实现。<br /> 我主动与公司的内外部利益相关方进行交流。<br /> 我坚持以清晰方式制定决策并进行充分沟通，从而充分了解如何去执行决策。</div>',
          enActivesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left">I understand our objectives and how my own priorities/actions will ensure we deliver them<br />I proactively engage the relevant internal and external stakeholders <br /> I insist that clear decisions are made and communicated and am clear on how I am expected to support their execution</div>',
          expectDetails: ""
        },
        {
          criterionType: "勇于承担",
          enCriterionType: "Accountability",
          activesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">我勇于承担，发挥主人翁精神，服从执行公司的决策。<br /> 我在制定绩效时，充分考虑所需的时间和资源<br /> 我将勇于承担责任以达成目标，即便部分超出个人责任范围之外。</div>',
          enActivesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">I demonstrate commitment, personal ownership and stick to decisions taken<br /> I plan for performance, taking into account time and resources needed<br /> I take personal responsibility for delivery, even when outside my immediate areas of responsibility</div>',
          expectDetails: ""
        },
        {
          criterionType: "付诸行动",
          enCriterionType: "Action",
          activesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">我在规定的时间内高质高效地完成工作。<br /> 当工作没有按预期进行的时候，我勇于迅速采取正确的行动使工作进展顺利。<br /> 团队目标实现为重，我个人同获殊荣；必要时，我乐意帮助团队成员并协作他们完成任务。</div>',
          enActivesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">I execute decisions with quality and on committed timeline<br /> I take fast corrective actions, when we are not on track <br /> I win when the whole plan is delivered, requiring me, if needed, to help team members deliver their actions</div>',
          expectDetails: ""
        }
      ],
      targetRevisionState: true,
      oldData: []
    };
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (this.tabName == "midTermReview" || this.tabName == "yearEndSummary") {
        if (this.tabName == "yearEndSummary") {
          if (this.userDeptFlag == "1") {
            if (this.status < 5) {
              this.columns5 = this.midBehaviorColumns.filter(function(e) {
                return !e.hidden;
              });
            } else {
              this.columns5 = this.midBehaviorColumns;
            }
          } else {
            this.columns5 = this.midBehaviorColumns;
          }
        } else if (this.tabName == "midTermReview") {
          this.columns5 = this.midBehaviorColumns;
        } else {
          this.columns5 = this.goalBehaviorColumns;
        }
      } else {
        this.columns5 = this.goalBehaviorColumns;
        this.$emit("onInter");
      }
    }
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    goalBehaviorColumns() {
      return [
        {
          title: /* "3A准则" */ this.$t("Triple_A"),
          key: this.lang == "zh" ? "criterionType" : "enCriterionType",
          align: "center",
          minWidth: 100,
          ellipsis: false
        },
        {
          title: /* "行为标准" */ this.$t("Attributes"),
          key: this.lang == "zh" ? "activesPerformed" : "enActivesPerformed",
          align: "center",
          type: "html",

          minWidth: 200
        },
        {
          title: /* "达成目标过程中的行为期望（可参考直线经理或其他相关方对您的反馈）" */ this.$t(
            "longText27"
          ),
          slot: "expectDetails",
          align: "center",
          minWidth: 260,
          ellipsis: true
        }
      ];
    },
    midBehaviorColumns() {
      return [
        {
          title: /* "3A准则" */ this.$t("Triple_A"),
          key: this.lang == "zh" ? "criterionType" : "enCriterionType",
          align: "center",
          minWidth: 100,
          ellipsis: false
        },
        {
          title: /* "行为标准" */ this.$t("Attributes"),
          key: this.lang == "zh" ? "activesPerformed" : "enActivesPerformed",
          align: "center",
          type: "html",

          minWidth: 200
        },
        {
          title: /* "达成目标过程中的行为期望（可参考直线经理或其他相关方对您的反馈）" */ this.$t(
            "longText27"
          ),
          slot: "expectDetails",
          align: "center",
          minWidth: 260,
          ellipsis: true
        },
        {
          title: /* "员工说明" */ this.$t("Employee_Comment"),
          slot: "empDetails",
          align: "center",
          minWidth: 300,
          ellipsis: true
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 虚线上级反馈 */,
          slot: "indirSupFeedback",
          align: "center",
          minWidth: 150,
          maxWidth: 150,
          ellipsis: true,
          hidden: true
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          slot: "dirSupFeedback",
          align: "center",
          minWidth: 225,
          maxWidth: 225,
          ellipsis: true,
          hidden: true
        }
      ];
    }
  },
  created() {
    if (this.tabName == "midTermReview" || this.tabName == "yearEndSummary") {
      this.getMidData();
    } else {
      this.columns5 = this.goalBehaviorColumns;
    }
  },
  methods: {
    getMidData() {
      if (this.tabName == "yearEndSummary") {
        if (this.userDeptFlag == "1") {
          if (this.status < 5) {
            this.columns5 = this.midBehaviorColumns.filter(function(e) {
              return !e.hidden;
            });
          }
        } else {
          this.columns5 = this.midBehaviorColumns;
        }
      } else if (this.tabName == "midTermReview") {
        this.columns5 = this.midBehaviorColumns;
      } else {
        this.columns5 = this.goalBehaviorColumns;
      }
    },
    targetItemChange(row, index, key) {
      key && this.$set(this.data5[index], key, row[`${key}`]);
      if (
        JSON.stringify(this.oldData[index]) !=
          JSON.stringify(this.data5[index]) &&
        !this.targetRevisionState
      ) {
        if (row.status != "新增") {
          /* && row.status!='删除' */
          this.$set(this.data5[index], "status", "编辑");
          this.$set(this.oldData[index], "status", "编辑");
        }
      } else if (!this.targetRevisionState) {
        this.$set(this.data5[index], "status", "");
        this.$set(this.oldData[index], "status", "");
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/BehaviorExpectation.vue